import { Link } from "react-router-dom";
import { Badge } from "../../components/ui/Badge";
import { TBody, TD, TH, THead, TR, Table } from "../../components/ui/Table";
import { formatDate, titleCase } from "../../lib/format";
import type { Product } from "../../lib/types";

const Thumbnail = ({ product }: { product: Product }) =>
	product.thumbnailUrl ? (
		<img
			src={product.thumbnailUrl}
			alt=""
			loading="lazy"
			className="h-10 w-10 rounded-md border border-line object-cover"
		/>
	) : (
		<div className="h-10 w-10 rounded-md border border-dashed border-line" />
	);

export const ProductsTable = ({ products }: { products: Product[] }) => (
	<Table>
		<THead>
			<TR>
				<TH className="w-14" />
				<TH>Product</TH>
				<TH className="w-28">Status</TH>
				<TH className="w-40">Vendor</TH>
				<TH className="w-48">Updated</TH>
			</TR>
		</THead>
		<TBody>
			{products.map((product) => (
				<TR key={product.id} className="hover:bg-raised">
					<TD>
						<Thumbnail product={product} />
					</TD>
					<TD>
						<Link
							to={`/products/${product.id}`}
							className="font-medium text-ink underline-offset-4 hover:underline"
						>
							{product.title ?? "Untitled product"}
						</Link>
						<p className="mt-0.5 text-xs text-ink-faint">{product.handle ?? "—"}</p>
					</TD>
					<TD>
						<Badge variant={product.status === "ACTIVE" ? "solid" : "outline"}>
							{titleCase(product.status)}
						</Badge>
					</TD>
					<TD className="text-ink-muted">{product.vendor ?? "—"}</TD>
					<TD className="text-xs text-ink-muted">{formatDate(product.shopifyUpdatedAt)}</TD>
				</TR>
			))}
		</TBody>
	</Table>
);
